import "../../src/assets/styles/Header.css";
import logo from "../imgs/logo.png";
import iconBack from "../icons/icon-back.png";
import { useNavigate } from "react-router-dom";

function Header({ isPageSearch, pageToAcction, data }) {
  const navigate = useNavigate();
  const backToSearch = () => {
  if (pageToAcction) navigate(pageToAcction,  { state: data })
  else navigate("/");
  };

  return (
    <div>
      <div className="header">
        <div className="status-bar"></div>
        <div className="header-logo">
          {!isPageSearch && (
            <img
              className="img-icon-back"
              style={{ cursor: "pointer" }}
              src={iconBack}
              alt="icon-back"
              id="btn-back"
              onClick={backToSearch}
            />
          )}
          <div className="main-logo">
            <img src={logo} alt="logo"></img>
          </div>
        </div>
        {/* {
          {
            "full_name":
            <div className="main-title main-title-name">
              <img src={imgTitleFullName} alt="logo"></img>
            </div>,
            "phone_number":
            <div className="main-title main-title-phone">
              <img src={imgTitlePhone} alt="logo"></img>
            </div>,
            "email":
            <div className="main-title main-title-email">
              <img src={imgTitleEmail} alt="logo"></img>
            </div>,
            "bank":
            <div className="main-title main-title-bank">
              <img src={imgTitleBank} alt="logo"></img>
            </div>,
          }[currentPage]
        } */}
          {/* {!currentPage && ( */}
            <div className="main-title main-title-cskh">
              <p>HỖ TRỢ KHÁCH HÀNG</p>
              {/* <img src={imgTitleSupCskh} alt="logo"></img> */}
            </div>
          {/* )} */}
        {/* <p>HỖ TRỢ KHÁCH HÀNG</p> */}
      </div>
    </div>
  );
}

export default Header;
